export default "__VITE_ASSET__DkMxGSOX__"